import DefaultNavbar from 'components/DefaultNavbar';
import DefaultFooter from 'components/DefaultFooter';
import DefaultHeader from 'components/DefaultHeader';
import DreamJoystickContent from 'components/mobile-app/DreamJoystickContent';
import MobileAppIcon from 'assets/img/dreamjoystick/icon.png';
import SupportSection from 'components/mobile-app/SupportSection';

export default function DreamJoystick() {
    return (
        <>
            <div className="absolute w-full z-20">
                <DefaultNavbar/>
            </div>
            <main>
                <DefaultHeader bg="bg-dreamjoystick-background" />
                <DreamJoystickContent title="Dream Joystick" icon={MobileAppIcon}/>
                <SupportSection />
            </main>
            <DefaultFooter />
        </>
    );
}
